import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-send-arrow",
  "use": "icon-s-send-arrow-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-send-arrow\"><path d=\"m22 0-8.105 22-4.632-9.263L0 8.105zm-3 3L5 8.158l5.895 2.948L13.842 17zm.633-2L21 2.367 10.367 13 9 11.633z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol